import SimulatorConfiguration from "../library/SimulatorHelper";
import SimulatorData from './SimulatorData';
import ISimulator from "./ISimulator";
import { Loft } from '../classes/Golfer';
import Fitter from '../classes/Fitter';
import AA_SL from '../classes/AaSl';


const wiFiIpAddress = "172.30.20.1";

const TrackManAdjustments = {
    dynamicLoftAdjustment: 2.7,
    attackAngleMinimum: -11,
    attackAngleMaximum: 0,
    attackAngleA: -0.0684,
    attackAngleB: -0.7637,
    attackAngleC: 0.1783,
    attackAngleNull_DLMultiplier: -.42,
    attackAngleNull_Modifier: -1.84,
    dynamicLoftNull_AAMultiplier: -1.07,
    dynamicLoftNull_Modifier: 3.56
}

export default class TrackMan2 implements ISimulator {

    modelType = "trackman";
    
    getUrl = (simulatorConfiguration: SimulatorConfiguration) => {
        let url = "";

        let ip = simulatorConfiguration.connectionType === "Ethernet" ? simulatorConfiguration.ethernetAddress : wiFiIpAddress;
        if (ip !== "*test*") {
            url = `ws://${ip}/ws`;
        }
        return url;
    }

    //given a practice shot, calculate the attack angle and shaft lean values
    //this will be different if it's for the history table (raw TM data) or for the grind calculations (modified using Titleist algorithms)
    calculateAttackAngleShaftLean = (loft: Loft, shotType: string, attackAngle: number, dynamicLoft: number, isForGrindCalculations: boolean, useRounding = true, fitter?: Fitter): AA_SL => {
        let newShaftLean = dynamicLoft !== undefined ? dynamicLoft : -999;
        let newAttackAngle = attackAngle !== undefined ? attackAngle : -999;
    
        //only adjust the values for internal grind calculations. For the grid, display the raw data
        //at least one of the values from TM needs to be valid to continue (otherwise TM sent us a bad reading and it will not be used in calculations)
        if (isForGrindCalculations && (attackAngle !== undefined || dynamicLoft !== undefined)) {
                //shaft lean = club loft - dynamic loft + adjustment
            if (dynamicLoft !== undefined) {
                newShaftLean = Number(loft) - dynamicLoft;
                if (isForGrindCalculations) {
                    newShaftLean = newShaftLean - TrackManAdjustments.dynamicLoftAdjustment;
                }
            }

            if (attackAngle !== undefined) {
                newAttackAngle = attackAngle;

                //only calculate the attack angle adjustment if it's within the min and max range and it's being used to plot/use for grinds
                if (attackAngle >= TrackManAdjustments.attackAngleMinimum && attackAngle <= TrackManAdjustments.attackAngleMaximum && isForGrindCalculations) {
                    //Titleist quadratic formula adjustment
                    newAttackAngle = attackAngle - ((Math.pow(attackAngle, 2) * TrackManAdjustments.attackAngleA) + attackAngle * TrackManAdjustments.attackAngleB + TrackManAdjustments.attackAngleC);
                }
            }

            //apply a normalization function based on the loft and shot type
            if (loft >= "54" && shotType == "Full") {
                newAttackAngle += 0.5;
                newShaftLean -= 0.5;
            }
            if (shotType == "Pitch") {
                newAttackAngle += 1;
                newShaftLean -= 1;
            }
            if (shotType == "Open Face") {
                newAttackAngle -= 1;
                newShaftLean += 1;
            }

            //now that both values have been calculated, if either one was undefined then calculate it's estimated value based on the other value
            //only do so if its for an internal calculation and  the fitter selected this option
            //        if (dynamicLoft === undefined && isForGrindCalculations && fitter && fitter.useEstimateDynamicLoft) {
            if (dynamicLoft === undefined && isForGrindCalculations) {
                newShaftLean = newAttackAngle * TrackManAdjustments.dynamicLoftNull_AAMultiplier + TrackManAdjustments.dynamicLoftNull_Modifier;
            }
            if (attackAngle === undefined) {
                newAttackAngle = newShaftLean * TrackManAdjustments.attackAngleNull_DLMultiplier + TrackManAdjustments.attackAngleNull_Modifier;
            }
        }

        //boundary case, JS rounds to -0 which looks weird to the user
        if (newAttackAngle.toFixed(0) === '-0') { newAttackAngle = 0 };
        var aa_sl = new AA_SL("--", "--");
        if (useRounding){
            aa_sl = new AA_SL(newAttackAngle < -900 ? "--" : String(newAttackAngle.toFixed(0)), newShaftLean < -900 ? "--" : String(newShaftLean.toFixed(0)));
        } else {
            aa_sl = new AA_SL(newAttackAngle < -900 ? "--" : String(newAttackAngle), newShaftLean < -900 ? "--" : String(newShaftLean));
        }
        return aa_sl;
    }

    handlePayload = (data: any) => {
        let simData = new SimulatorData();
        if (data) {
            simData = new SimulatorData(data.Id, data.Payload.AttackAngle, data.Payload.DynamicLoft, data.Payload.BallSpeed, data.Payload.ClubSpeed, data.Payload.ClubSpeed, data.Payload.LaunchAngle, data.Payload.SpinRate, data.Payload.Carry);
        }
        return simData;
    }

    isValidShotPayload = (data: any) => {
        if (data) {
            return data.Payload && data.Payload.Kind == "Measurement" && data.Payload.Carry && data.Type == "Measurement";
        }
    }

}